function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFont14 = function SvgFont14(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.855,
    height: 8.019
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25809",
    d: "M.914-3.36a1.619 1.619 0 0 1 .253-.889 1.6 1.6 0 0 1 .7-.6A10.778 10.778 0 0 0 .462-5.1a3.026 3.026 0 0 1 .465-1.619 3.013 3.013 0 0 1 1.259-1.095A4.2 4.2 0 0 1 4.033-8.2a3.944 3.944 0 0 1 1.717.356 2.744 2.744 0 0 1 1.156.992 2.653 2.653 0 0 1 .411 1.471v5.2H5.566v-5.013a1.6 1.6 0 0 0-.458-1.184A1.637 1.637 0 0 0 3.9-6.836a2.389 2.389 0 0 0-1.143.274 1.426 1.426 0 0 0-.691.712 7.216 7.216 0 0 1 .883.246 3.3 3.3 0 0 1 .7.328v.493a1.553 1.553 0 0 0-.732.52 1.342 1.342 0 0 0-.253.821v3.257H.914z",
    transform: "translate(-.463 8.204)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgFont14;